<template>

    <cms-modal :title="modalTitle" @close="dismiss">

        <cms-form submit-button="Opslaan" :submitting="submitting" @submit="submit" v-spinner="loading">

            <cms-form-date-picker :title="startDateTitle" v-model="data.startDate" name="startDate" input="true"
                v-validate="shouldValidateDate ? 'required|date_format:YYYY-MM-DD|before:' + beforeDate : 'required'" data-vv-as="Start datum" :error="error('startDate')"></cms-form-date-picker>

            <cms-form-date-picker title="(Verwachte) Eind datum" v-model="data.endDate" v-if="shouldShowEndDate" name="endDate" input="true"
                                  v-validate="endDateRules" data-vv-as="Eind datum" :error="error('endDate')"></cms-form-date-picker>

            <cms-form-input title="Referentie" v-model="data.reference" v-if="shouldShowReference" name="reference"
                            v-validate="'required'" data-vv-as="Referentie" :error="error('reference')"></cms-form-input>

            <cms-form-dropdown title="Project" searchable="true" max-height="150" :options="projectOptions" v-model="data.projectId" v-if="shouldShowProject"
                               v-validate="'required'" data-vv-as="Project" data-vv-name="project" :error="error('project')"></cms-form-dropdown>

            <cms-form-input title="Vervangende logger" hint="Serienummer" v-model="data.replacementLoggerSerialNumber" v-if="shouldShowReplacementLogger" name="replacementLoggerSerialNumber"
                            v-validate="'required'" data-vv-as="Vervangende logger" :error="error('replacementLoggerSerialNumber')"></cms-form-input>

            <cms-form-textarea title="Opmerkingen" v-model="comments" v-if="!entries && action !== 'REPAIR_ACTIVE'"></cms-form-textarea>

        </cms-form>

    </cms-modal>

</template>

<script>

    import Component from 'vue-class-component'
    import Vue from 'global-vue'
    import moment from 'moment'

    import find from 'lodash/find'
    import map from 'lodash/map'

    import ProjectQueries from 'app/queries/ProjectQueries'
    import LoggerMutations from 'app/mutations/LoggerMutations'

    import LoggerAction from 'app/enums/LoggerAction'

    class Actions {

        static DEPLOY = 'DEPLOY';
        static RETOUR = 'RETOUR';
        static RELEASE = 'RELEASE';
        static REPAIR_PENDING = 'REPAIR_PENDING';
        static REPAIR_ACTIVE = 'REPAIR_ACTIVE';
        static WRITE_OFF = 'WRITE_OFF';
        static TRANSFER = 'TRANSFER';
        static REPLACE = 'REPLACE';
    }

    @Component({

        name: 'logger-mutation-modal',
        props: ['action', 'loggers', 'entries'],

        apollo: {

            projects: ProjectQueries.allCodes({

                fetchPolicy: 'cache-and-network',

                skip(){

                    return !this.shouldShowProject;
                }
            })
        }
    })
    export default class extends Vue
    {
        data(){

            return {

                loading: 0,
                submitted: false,
                submitting: false,
                comments: null,

                data: {
                    startDate: moment().format('Y-MM-DD'),
                    endDate: null,
                    projectId: this.getDefaultProjectId(),
                    replacementLoggerSerialNumber: null,
                    reference: null
                }
            }
        }

        mounted(){

            // Set default end date if needed
            if(this.action === Actions.REPLACE){

                var thisLogger = this.loggers[0];
                this.data.endDate = thisLogger.activeAllocation.endDate;
            }
        }

        get modalTitle(){

            switch(this.action){

                case Actions.DEPLOY: return 'Logger(s) inzetten';
                case Actions.RETOUR: return 'Logger(s) retourneren';
                case Actions.RELEASE: return 'Logger(s) vrijgeven';
                case Actions.REPAIR_PENDING: return 'Logger(s) ter reparatie';
                case Actions.REPAIR_ACTIVE: return 'Reparatie aanmaken';
                case Actions.WRITE_OFF: return 'Logger(s) afschrijven';
                case Actions.TRANSFER: return 'Logger(s) overdragen';
                case Actions.REPLACE: return 'Logger(s) vervangen';
            }

            return '';
        }

        get beforeDate(){

            return moment().add(1, 'day').format('Y-MM-DD');
        }

        get startDateTitle(){

            return this.action === Actions.RETOUR ? 'Retour datum' : 'Start datum';
        }

        get shouldValidateDate(){

            return this.action !== Actions.REPAIR_ACTIVE;
        }

        get projectOptions(){

            return this.projects ? this.projects.items.map(project => ({ label: project.code, value: project.id })) : [];
        }

        get shouldShowProject(){

            return [Actions.DEPLOY, Actions.TRANSFER].indexOf(this.action) != -1;
        }

        get shouldShowReplacementLogger(){

            return this.action === Actions.REPLACE;
        }

        get shouldShowEndDate(){

            return [Actions.DEPLOY, Actions.TRANSFER, Actions.REPAIR_ACTIVE, Actions.REPLACE].indexOf(this.action) != -1;
        }

        get endDateRules(){

            return this.action === Actions.REPAIR_ACTIVE ? 'required' : '';
        }

        get shouldShowReference(){

            return [Actions.REPAIR_ACTIVE].indexOf(this.action) != -1;
        }

        get apiAction(){

            switch(this.action){

                case Actions.DEPLOY: return LoggerAction.DEPLOY;
                case Actions.RETOUR: return LoggerAction.RETOUR;
                case Actions.RELEASE: return LoggerAction.RELEASE;
                case Actions.REPAIR_PENDING: return LoggerAction.REPAIR_PENDING;
                case Actions.REPAIR_ACTIVE: return LoggerAction.REPAIR_ACTIVE;
                case Actions.WRITE_OFF: return LoggerAction.WRITE_OFF;
                case Actions.TRANSFER: return LoggerAction.TRANSFER;
                case Actions.REPLACE: return LoggerAction.REPLACE;
            }
        }

        get resolvedEntries(){

            if(this.entries){

                return this.entries.map(entry => ({ loggerId: entry.logger.id, comments: entry.comments }));
            }
            else {

                return this.loggers.map(logger => ({ loggerId: logger.id, comments: this.comments }));
            }
        }

        cancel(){

            this.dismiss();
        }

        getDefaultProjectId(){

            if(this.action != LoggerAction.TRANSFER){
                return null;
            }

            var loggers = this.entries ? map(this.entries, 'logger') : this.loggers;
            var firstLogger = loggers.length > 0 ? loggers[0] : null;

            if(firstLogger && firstLogger.activeAllocation && (firstLogger.activeAllocation.project || firstLogger.activeAllocation.projectId)){
                return (firstLogger.activeAllocation.projectId || firstLogger.activeAllocation.project.id).toString();
            }

            return null;
        }

        error(field){

            return this.submitted ? this.errors.first(field) : null;
        }

        submit(){

            this.submitted = true;

            this.$validator.validateAll().then(success => {

                if (!success) {

                    this.$toast.error('Er zijn één of meerdere fouten');
                    return;
                }

                const input = {

                    action: this.apiAction,
                    data: this.data,
                    entries: this.resolvedEntries
                };

                if(this.action == LoggerAction.TRANSFER && this.data.projectId != this.getDefaultProjectId()){

                    const projectCode = find(this.projectOptions, { value: this.data.projectId }).label;

                    this.$alert.confirm(`Weet je zeker dat je deze logger wil overdragen naar ${projectCode}?`, false, { subtitle: 'Overdragen van loggers kan effect hebben op de facturatie.' }).then(({ result }) => {

                        if(result){
                            this.sendAction(input);
                        }
                    });
                }
                else {

                    this.sendAction(input);
                }
            });
        }

        sendAction(input){

            this.$logger.info('Executing logger action', input);

            this.submitting = true;

            LoggerMutations.executeAction(input).then(() => {

                this.submitting = false;
                this.$emit('dismiss', true);

            }).catch(error => {

                const errors = map(error.graphQLErrors, 'message');
                this.$logger.error('Error executing action', error);

                if(errors.indexOf('logger-serial-invalid') >= 0){
                    this.$toast.error('Het gekozen serienummer is niet in gebruik');
                }
                else if(errors.indexOf('logger-allocated') >= 0){
                    this.$toast.error('De vervangende logger is nog ingezet bij een ander project');
                }
                else {
                    this.$toast.error('Kon de loggers niet opslaan');
                }

                this.submitting = false;
            });
        }

        dismiss(){

            this.$emit('dismiss');
        }
    }

</script>
